import React from 'react';

const ArrowLeftBig = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.9888 8.38184L11.2898 4.43939C11.7147 4.0499 11.7147 3.38002 11.2898 2.99053C10.914 2.64613 10.3374 2.64613 9.96168 2.99053L4.88428 7.64467C4.4519 8.04101 4.4519 8.72266 4.88428 9.119L9.96168 13.7731C10.3374 14.1175 10.914 14.1175 11.2898 13.7731C11.7147 13.3837 11.7147 12.7138 11.2898 12.3243L6.9888 8.38184Z",
      fill: "white"
    }
  )
);
ArrowLeftBig.displayName = "Icons.ArrowLeftBig";

export { ArrowLeftBig };
//# sourceMappingURL=ArrowLeftBig.js.map
